import React, { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';


function SeoHeadTag() {
  const { t, i18n } = useTranslation();
  const description = t('common.nagativeWaste') + " 〜 " + t('common.makePositiveHabit') + " 〜 " + t('common.application');

  return (
    <Helmet>
      <title>{t('seo.title')}</title>
      <meta name="keywords" content={t('seo.keywords')} />
      <meta name="description" content={description} />

      <meta property="og:site_name" content={t('seo.title')} />
      <meta property="og:title" content={t('seo.title')} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content="https://inspireme-hub.web.app/" />

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={t('seo.title')} />
      <meta property="twitter:description" content={description} />
    </Helmet>
  );
}

export default SeoHeadTag;